import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {ContractEvent} from "../../../model/contract-event";
import {Observable, of} from "rxjs";
import {MatDialog} from "@angular/material/dialog";
import {DialogsService} from "../../../services/dialogs.service";
import {SnackService} from "../../../services/snack.service";
import {Router} from "@angular/router";
import {switchMap, tap} from "rxjs/operators";
import {Sort} from "@angular/material/sort";
import {ContractsService} from "../../../services/contracts.service";
import {AuthService} from "../../../services/auth.service";
import {
  GeneralItemDetailDialogComponent
} from "../../../shared-components/general-item-detail-dialog/general-item-detail-dialog.component";
import {hasAnyPermission, User} from "../../../model/user";

@Component({
  selector: 'aw-list-contract-events',
  templateUrl: './list-contract-events.component.html',
  styleUrls: ['./list-contract-events.component.scss']
})
export class ListContractEventsComponent implements OnInit {

  public displayedColumns = [

    'timestamp',
    'previousState',
    'appliedState',
    'createdBy',
    'action',
  ];
  disabled = false;
  disabledItemId: number[] = [];
  loading = false;

  @ViewChild('paginatorContractEvents') paginatorUsers!: MatPaginator;
  @Input() contractId!: number;

  dataSource!: MatTableDataSource<ContractEvent>;
  expandedContractElement?: ContractEvent;
  private allContractEvents$?: Observable<ContractEvent[]>;
  private loggedUser: User;

  constructor(
    public dialog: MatDialog,
    private contractsService: ContractsService,
    private authService: AuthService,
    private dialogsService: DialogsService,
    private snackService: SnackService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.loggedUser = this.authService.loggedUser();
  }

  ngAfterViewInit(): void {
    this.allContractEvents$ =
      of(true)
        .pipe(
          tap(() => this.loading = true),
          switchMap(() => {
            if (hasAnyPermission(this.loggedUser, ["admin", 'customer']))
              return this.contractsService.getAllContractEvents(this.contractId);
            else
              return of([]);
          }),
          tap(x => {

            x.forEach(event => event.appliant = event.createdBy?.identityProviderId === '0' ? 'AUTO' : `${(event.createdBy as User)?.firstName} ${(event.createdBy as User)?.lastName}`);

            this.dataSource = new MatTableDataSource<ContractEvent>(x);
            this.dataSource.paginator = this.paginatorUsers;
            this.loading = false;
          })
        );
    this.allContractEvents$.subscribe();
  }

  applyFilters(event: string): void {
    this.dataSource.filter = event.trim().toLowerCase();
  }

  doSortContractEvents(event: Sort): void {
    this.dataSource.paginator?.firstPage();
    this.dataSource.data = this.dataSource.data.sort((a, b) => {


      const index: string = event.active;

      if (event.active === 'createdBy') {
        if (event.direction === 'asc') {
          return ('' + b.createdBy?.firstName).localeCompare('' + a.createdBy?.firstName);
        } else {
          return ('' + a.createdBy?.firstName).localeCompare('' + b.createdBy?.firstName);
        }
      }

      if (event.direction === 'asc') {
        return ('' + (b as any)[index]).localeCompare('' + (a as any)[index]);
      } else {
        return ('' + (a as any)[index]).localeCompare('' + (b as any)[index]);
      }


    });
  }

  details(contractEvent: ContractEvent): void {
    this.dialog.open(GeneralItemDetailDialogComponent, {data: contractEvent});
  }


}
